<!-- 车辆管理界面 -->
<template>
  <div class="access-record-container">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
            @selection-change="handleSelectionChange"
          >
            <!-- 表格按钮 自定义 -->
            <template slot="search_parkType">
              <div>
                <el-select v-model="searchParams.parkType" placeholder="请选择">
                  <el-option
                    v-for="item in parkTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
            <!-- 车辆权限-->
            <template slot="search_listType">
              <div>
                <el-select v-model="searchParams.listType" placeholder="请选择">
                  <el-option
                    v-for="item in listTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
            <!-- 上方按钮 -->
            <template slot="menuLeft">
              <el-button
                type="primary"
                size="small"
                class="iss-operation-button"
                icon="el-icon-plus"
                @click="handleAddCar"
              >
                新增
              </el-button>
              <el-button
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
                @click="handelDelCars"
                :disabled="!checkedCarIds.length ? true : false"
              >
                批量删除
              </el-button>
              <!-- <el-button
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
                @click="handelImportCar"
              >
                导入
              </el-button>
              <el-button
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
                @click="handelExportCar"
              >
                导出
              </el-button> -->
            </template>
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="编辑"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  v-auth="'/account/index:update'"
                  type="text"
                  icon="iconfont icon-xiugai"
                  @click="handleEdit(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  v-auth="'/account/index:delete'"
                  type="text"
                  icon="iconfont icon-shanchu"
                  @click="handleDel(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="750"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="车辆详情"
    >
      <div class="panel-content">
        <el-form
          style="height: 99%; position: absolute; width: 100%"
          :inline="true"
          :model="carDetailInfo"
          ref="carDetailForm"
          label-width="96px"
          label-position="right"
          label-suffix=" ："
        >
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号">
                  <div>
                    {{ carDetailInfo.carNum ? carDetailInfo.carNum : "暂无" }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车身颜色">
                  <div>
                    {{
                      carDetailInfo.carColor
                          ? getDataLabel(carDetailInfo.carColor, carColorOptions)
                          : "暂无车身颜色"
                    }}
                  </div>
                </el-form-item>
              </el-col>
<!--              <el-col :span="12">-->
<!--                <el-form-item label="车辆权限">-->
<!--                  <div>-->
<!--                    {{-->
<!--                      carDetailInfo.listType == "0"-->
<!--                        ? "正常"-->
<!--                        : carDetailInfo.listType == "1"-->
<!--                        ? "白名单"-->
<!--                        : carDetailInfo.listType == "2"-->
<!--                        ? "黑名单"-->
<!--                        : "暂无"-->
<!--                    }}-->
<!--                  </div>-->
<!--                </el-form-item>-->
<!--              </el-col>-->
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="车辆类型">
                  <div>
                    {{
                      carDetailInfo.carType
                        ? getDataLabel(carDetailInfo.carType, carTypeOptions)
                        : "暂无车辆类型"
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="停车场">
                  <div>{{ carDetailInfo.parkingLotName }}</div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="所属部门">
                  <div>
                    {{
                      carDetailInfo.deptName
                        ? carDetailInfo.deptName
                        : "暂无所属部门"
                    }}
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车主姓名">
                  <div>
                    {{
                      carDetailInfo.ownerName
                        ? carDetailInfo.ownerName
                        : "暂无车主姓名"
                    }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌颜色">
                  {{
                    carDetailInfo.carNumColor ? getDataLabel(carDetailInfo.carNumColor, carNumColorOptions) : "暂无车牌颜色"
                  }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆品牌">
                  {{
                    carDetailInfo.carBrand ? getDataLabel(carDetailInfo.carBrand, carBrandOptions) : "暂无车辆品牌"
                  }}
                </el-form-item>
              </el-col>
            </el-row>


            <el-row class="car-info-box">
              <el-col :span="24">
                <el-form-item label="备注">
                  <div>{{ carDetailInfo.memo }}</div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>

    <!-- 新增/修改 -->
    <appPanel
      :width="800"
      class="app-panel"
      :isExpand="showAddOrEditPanel"
      @cancel="handleCloseAddOrEditPanel"
      :title="title"
    >
      <!-- 内容区域 -->
      <div>
        <el-form
          style="height: 99%; position: absolute; width: 100%"
          :inline="true"
          :model="carFromInfo"
          :rules="carFromRule"
          ref="carForm"
          label-width="96px"
          label-position="right"
          label-suffix=" :"
        >
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="12">
                <el-form-item label="车牌号" prop="carNum">
                  <el-input
                    v-model="carFromInfo.carNum"
                    placeholder="请输入车牌号"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车辆类型" prop="carType">
                  <el-select v-model="carFromInfo.carType" placeholder="请选择">
                    <el-option
                      v-for="item in carTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="停车场" prop="parkinglotCodes">
                  <!-- multiple -->
                  <el-select
                    v-model="carFromInfo.parkinglotCodes"
                    placeholder="请选择停车场"
                    clearable
                    multiple
                    @change="changeSelectedParkLot"
                  >
                    <el-option
                      v-for="item in parkLotOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所属部门" prop="deptId">
                  <el-select
                    v-model="carFromInfo.deptId"
                    placeholder="请选择"
                    @change="changeSelectedDept"
                  >
                    <el-option
                      v-for="item in deptIdOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="车主姓名" prop="ownerId">
                  <el-select
                    v-model="carFromInfo.ownerId"
                    placeholder="请选择"
                    @change="changeSelectedOwner"
                  >
                    <el-option
                      v-for="item in personIdOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车牌颜色" prop="carNumColor">
                  <el-select
                    v-model="carFromInfo.carNumColor"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in carNumColorOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="车辆品牌" prop="carBrand">
                  <el-select
                    v-model="carFromInfo.carBrand"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in carBrandOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="车身颜色" prop="carColor">
                  <el-select
                    v-model="carFromInfo.carColor"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in carColorOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row class="car-info-box">
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    type="textarea"
                    v-model="carFromInfo.memo"
                    placeholder="请输入备注"
                    style="width: 100%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>

      <!-- 按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleCloseAddOrEditPanel"
          type="info"
          :loading="subLoading"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :loading="subLoading"
          @click="handleSaveAddOrEditPanel"
        >
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/manageTable";
export default {
  components: {
    appPanel,
  },
  data() {
    return {
      form: {},
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 选择的carId
      checkedCarIds: [],
      // 详情表单信息
      detailId: "",
      carDetailInfo: {
        id: undefined,
        carCode: "",
        carNum: "",
        listType: "",
        carType: "",
        parkinglotCodes: [],
        // 停车场名称
        parkingLotNames: [],
        deptId: "",
        deptName: "",
        ownerId: "",
        ownerName: "",
        carNumColor: "",
        carBrand: "",
        carColor: "",
        parkType: "",
        memo: "",
      },
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      carFromInfo: {
        id: undefined,
        carNum: "",
        carType: null,
        parkinglotCodes: [],
        // 停车场名称
        parkingLotNames: [],
        deptId: "",
        deptName: "",
        ownerId: "",
        ownerName: "",
        carNumColor:null,
        carBrand: null,
        carColor: null,
        memo: "",
      },
      carFromRule: {
        carNum: [
          {
            required: true,
            message: "请输入车牌号牌",
            trigger: ["blur", "change"],
          },
        ],
        carType: [
          {
            required: true,
            message: "请选择车辆类型",
            trigger: ["blur", "change"],
          },
        ],
        parkinglotCodes: [
          {
            required: true,
            message: "请选择停车场",
            trigger: ["blur", "change"],
          },
        ],
        deptId: [
          {
            required: true,
            message: "请选择车主",
            trigger: ["blur", "change"],
          },
        ],
        ownerId: [
          {
            required: true,
            message: "请选择所属部门",
            trigger: ["blur", "change"],
          },
        ],
        carNumColor: [
          {
            required: true,
            message: "请选择车牌颜色",
            trigger: ["blur", "change"],
          },
        ],
        carBrand: [
          {
            required: true,
            message: "请选择车辆品牌",
            trigger: ["blur", "change"],
          },
        ],
        carColor: [
          {
            required: true,
            message: "请选择车身颜色",
            trigger: ["blur", "change"],
          },
        ]
      },
      // 下拉选项信息
      listTypeOptions: [
        {
          value: 1,
          label: "白名单",
        },
        {
          value: 2,
          label: "黑名单",
        },
        {
          value: 0,
          label: "正常",
        },
      ],
      parkTypeOptions: [
        {
          value: "1",
          label: "普通车",
        },
        {
          value: "2",
          label: "专有车",
        },
      ],
      deptIdOptions: [{ value: "1", label: "根部门" }],
      carTypeOptions: [
        {
          value: "0",
          label: "未识别",
        },
        {
          value: "1",
          label: "小型汽车",
        },
        {
          value: "2",
          label: "大型汽车",
        },
        {
          value: "3",
          label: "使馆汽车",
        },
        {
          value: "4",
          label: "领馆汽车",
        },
        {
          value: "5",
          label: "境外汽车",
        },
        {
          value: "6",
          label: "外籍汽车",
        },

        {
          value: "10",
          label: "教练车",
        },
        {
          value: "11",
          label: "临时行驶车",
        },
        {
          value: "12",
          label: "警用汽车",
        },
        {
          value: "13",
          label: "应急汽车",
        },
        {
          value: "14",
          label: "武警汽车",
        },
        {
          value: "15",
          label: "军用汽车",
        },
        {
          value: "16",
          label: "民航汽车",
        },
        {
          value: "17",
          label: "新能源汽车",
        }
      ],
      carDeptOptions: [
        {
          value: "1",
          label: "职能部门",
        },
        {
          value: "2",
          label: "研发部门",
        },
      ],
      carColorOptions: [
        {
          value: "0",
          label: "白色",
        },
        {
          value: "1",
          label: "黑色",
        },
        {
          value: "2",
          label: "红色",
        },
        {
          value: "3",
          label: "黄色",
        },
        {
          value: "4",
          label: "银灰色",
        },
        {
          value: "5",
          label: "蓝色",
        },
        {
          value: "6",
          label: "绿色",
        },
        {
          value: "7",
          label: "橙色",
        },
        {
          value: "8",
          label: "紫色",
        },
        {
          value: "9",
          label: "青色",
        },
        {
          value: "10",
          label: "粉色",
        },
        {
          value: "11",
          label: "棕色",
        },
        {
          value: "99",
          label: "未识别",
        },
        {
          value: "100",
          label: "其他",
        },
      ],
      carNumColorOptions: [
        {
          value: "0",
          label: "蓝色",
        },
        {
          value: "1",
          label: "黄色",
        },
        {
          value: "2",
          label: "白色",
        },
        {
          value: "3",
          label: "黑色",
        },
        {
          value: "4",
          label: "绿色",
        },
        {
          value: "99",
          label: "未识别",
        },
        {
          value: "100",
          label: "其它颜色",
        },
      ],
      carBrandOptions: [
        {
          value: "-1",
          label: "其他",
        },
        {
          value: "0",
          label: "未识别",
        },
        {
          value: "1",
          label: "奥迪",
        },
        {
          value: "2",
          label: "本田",
        },
        {
          value: "3",
          label: "别克",
        },
        {
          value: "4",
          label: "大众",
        },
        {
          value: "5",
          label: "丰田",
        },
        {
          value: "6",
          label: "宝马",
        },
        {
          value: "7",
          label: "标致",
        },
        {
          value: "8",
          label: "福特",
        },
        {
          value: "9",
          label: "马自达",
        },
        {
          value: "10",
          label: "尼桑",
        },
        {
          value: "11",
          label: "现代",
        },
        {
          value: "12",
          label: "铃木",
        },
        {
          value: "13",
          label: "雪铁龙",
        },
        {
          value: "14",
          label: "奔驰",
        },
        {
          value: "15",
          label: "比亚迪",
        },
        {
          value: "16",
          label: "吉利",
        },
        {
          value: "17",
          label: "雷克萨斯",
        },
        {
          value: "18",
          label: "雪佛兰",
        },
        {
          value: "19",
          label: "奇瑞",
        },
        {
          value: "20",
          label: "起亚",
        },
        {
          value: "21",
          label: "夏利",
        },
        {
          value: "22",
          label: "东风",
        },
        {
          value: "23",
          label: "依维柯",
        },
        {
          value: "24",
          label: "五菱",
        },
        {
          value: "25",
          label: "金杯",
        },
        {
          value: "26",
          label: "保时捷",
        },
        {
          value: "27",
          label: "法拉利",
        },
        {
          value: "28",
          label: "兰博基尼",
        },
      ],
      parkLotOptions: [],
      personIdOptions: [],
      selectedDeptId: "",
    };
  },
  mounted() {
    this.getList();
    this.getParkLotList();
    // 获取部门数据
    this.getDeptData();
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  methods: {
    getDataLabel(val, data) {
      return data[data.findIndex(v => v.value === val)].label
    },
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getList();
      }, 1000 * 60 * 2);
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.value = item.deptCode;
          entity.label = item.deptName;
          result.push(entity);

          if (item.children) {
            item.children.forEach((sItem) => {
              let sObj = {
                value: sItem.deptCode,
                label: sItem.deptName,
              };
              result.push(sObj);
            });
          }
        });
        return result;
      }
    },
    //获取部门列表
    getDeptData() {
      this.$fetch(api.manage.queryDeptTree, { type: 1 }).then((response) => {
        if (!response.returnObj.length) {
          this.$message.error(response.msgContent);
          return;
        }
        const result = this.menusDataPro(response.returnObj);
        this.deptIdOptions = Object.freeze(result);
        this.selectedDeptId = this.deptIdOptions[0].value;
        this.carFromInfo.deptName = this.deptIdOptions[0].label;
        this.getPersonDataByDeptCode();
      });
    },

    // 获取当前部门下的人员信息
    getPersonDataByDeptCode() {
      let param = {
        personnelType: 1,
        pageNum: 1,
        pageSize: 1000,
        departmentCodeList: [this.selectedDeptId],
      };
      this.$fetch(api.manage.queryPersonnelListByDeptCode, param).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          let arr = response.returnObj.list;
          if (arr.length > 0) {
            this.personIdOptions = arr.map((item) => {
              let newItem = {
                label: item.name,
                value: item.personnelCode,
              };
              return newItem;
            });
            console.log("--personIdOptions:--", this.personIdOptions);
          } else {
            this.personIdOptions = [];
          }
        }
      );
    },
    // 选择停车场
    changeSelectedParkLot(val) {
      console.log("--选择停车场-val:-", val);
      // parkLotOptions
      this.carFromInfo.parkingLotNames = [];
      if (val.length > 0) {
        this.parkLotOptions.forEach((item) => {
          val.forEach((vItem) => {
            if (item.value == vItem) {
              this.carFromInfo.parkingLotNames.push(item.label);
            }
          });
        });
      }
      console.log("-parkingLotNames:-", this.carFromInfo.parkingLotNames);
    },
    // 选择部门
    changeSelectedDept(val) {
      this.selectedDeptId = val;
      // self.deptIdOptions[0].label
      let sArray = this.deptIdOptions.filter((item) => item.value === val);
      this.carFromInfo.deptId = val;
      this.carFromInfo.deptName = sArray[0].label;
      this.carFromInfo.ownerId = null
      this.getPersonDataByDeptCode();
    },
    // 选择车主
    changeSelectedOwner(val) {
      let oArray = this.personIdOptions.filter((item) => item.value === val);
      this.carFromInfo.ownerId = val;
      this.carFromInfo.ownerName = oArray[0].label;
    },
    // 车辆管理列表数据
    getList() {
      const params = {};
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      params.ownerNameLikeStr = this.searchParams.ownerName;
      params.parkinglotCode = this.searchParams.parkinglotCodes;
      params.carNumLikeStr = this.searchParams.carNum;
      params.parkinglotName = this.searchParams.parkingLotName;

      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.manage.queryVehicleList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.handSetTime();
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // 获取停车场列表数据
    getParkLotList() {
      //
      this.$fetch(api.manage.queryParkLotList, {}).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        if (response.returnObj.length > 0) {
          this.parkLotOptions = response.returnObj.map((item) => {
            let newItem = {
              label: item.parkingLot,
              value: item.parkingLotCode,
            };
            return newItem;
          });
        } else {
          this.parkLotOptions = [];
        }
        console.log("--this.parkLotOptions:---", this.parkLotOptions);
      });
    },

    handleView(row, index) {
      this.showPanel = true;
      console.log("--车辆详情--row:--", row);
      this.detailId = row.id;
      // this.carDetailInfo = row;
      this.getCarDetailInfo();
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      this.searchParams = param;
      // let tempObj = {};
      // tempObj.startTime = this.searchParams.startTime;
      // tempObj.endTime = this.searchParams.endTime;

      // this.searchParams = Object.assign(param);
      // console.log(this.searchParams, "===query");
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.searchParams.startTime = "";
      this.searchParams.endTime = "";
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSelectionChange(items) {
      console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedCarIds = [];
      } else {
        this.checkedCarIds = items.map((item) => {
          return item.id;
        });
      }
      console.log("----this.checkedCarIds:---", this.checkedCarIds);
    },
    // 新增车辆信息
    handleAddCar() {
      console.log("新增车辆信息");
      this.title = "添加车辆";
      this.showAddOrEditPanel = true;
    },
    // 批量删除车辆信息
    handelDelCars() {
      console.log("批量删除车辆信息");

      this.$confirm("您确定批量删除所选择的车辆信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.manage.deleteVehicle, this.checkedCarIds).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getList();
          }
        );
      });
    },
    // 导入车辆信息
    handelImportCar() {
      console.log("导入车辆信息");
    },
    // 导出车辆信息
    handelExportCar() {
      console.log("导出车辆信息");
    },
    // 编辑车辆信息
    handleEdit(row, index) {
      console.log("编辑车辆信息");
      this.title = "修改车辆";
      this.showAddOrEditPanel = true;
      this.detailId = row.id;
      // this.carFromInfo = row;
      this.getCarDetailInfo();
      console.log("---this.carFromInfo:--", this.carFromInfo);
    },
    // 获取车辆详情数据
    getCarDetailInfo() {
      this.$fetch(api.manage.queryVehicle, { id: this.detailId }).then(
        (response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          let obj = response.returnObj;
          if (this.showAddOrEditPanel) {
            this.carFromInfo = obj;
          } else if (this.showPanel) {
            this.carDetailInfo = obj;
          }
          this.selectedDeptId = this.carFromInfo.deptId
          this.getPersonDataByDeptCode();
        }
      );
    },
    handleDel(row) {
      console.log("删除车辆信息");

      this.$confirm("您确定删除该车辆信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.manage.deleteVehicle, [row.id]).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList();
        });
      });
    },
    // 关闭新增/修改 弹窗
    handleCloseAddOrEditPanel() {
      // TODO处理from表单取消校验操作
      this.handleRestForm();
      this.showAddOrEditPanel = false;
    },
    // 保存新增/修改 弹窗
    handleSaveAddOrEditPanel() {
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      // this.showAddOrEditPanel = false;
      this.$refs.carForm.validate((valid) => {
        if (valid) {
          let params = {
            ...this.carFromInfo
          };
          console.log("---params.id:---", params.id);
          if (params.id) {
            // 修改
            this.$fetch(api.manage.updateVehicle, params).then((res) => {
              if (res.success) {
                // 关闭弹窗
                this.showAddOrEditPanel = false;
                this.handleRestForm();
                // 刷新列表数据
                this.getList();
              } else {
                this.$message.error(res.msgContent)
              }

            });
          } else {
            // 新增
            this.$fetch(api.manage.addVehicle, params).then((res) => {
              if (res.success) {
                // 关闭弹窗
                this.showAddOrEditPanel = false;
                this.handleRestForm();
                // 刷新列表数据
                this.getList();
              } else {
                this.$message.error(res.msgContent)
              }
            });
          }
        } else {
          // this.showAddOrEditPanel = false;
          // this.handleRestForm();
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.carFromInfo = {
        id: undefined,
        carNum: "",
        carType: null,
        parkinglotCodes: [],
        parkingLotNames: [],
        deptId: "",
        deptName: "",
        ownerId: "",
        ownerName: "",
        carNumColor:null,
        carBrand: null,
        carColor: null,
        memo: "",
      }
      this.$refs["carForm"].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;
    .el-form-item__content {
      flex: 1;
    }
  }
}
</style>
